import request from "@/utils/request";
export function login(data) {
  return request({
    url: "/sysUser/login",
    method: "post",
    data,
  });
}
// 重置密码
export function resetPassword(data: any) {
  return request({
    url: "/sysUser/updatePass",
    method: "post",
    data,
  });
}
// 重置财务密码
export function resetFinancialPassword(data: any) {
  return request({
    url: "/sysUser/updateFinancialPass",
    method: "post",
    data,
  });
}
// 退出登录
export function loginOut(data: any) {
  return request({
    url: "/sysUser/logout",
    method: "post",
    data,
  });
}
// 投放数据列表
export function sysNovelUserOrderList(data: any) {
  return request({
    url: "/sysNovelUserOrder/queryList",
    method: "get",
    params: data,
  });
}
// 投放数据修改
export function sysNovelUserOrderSave(data: any) {
  return request({
    url: "/sysNovelUserOrder/save",
    method: "post",
    data,
  });
}
// 应用列表
export function sysNovelConfigList(data: any) {
  return request({
    url: "/sysNovelConfig/queryListAll",
    method: "get",
    params: data,
  });
}
// 小说数据
export function sysNovelUserOrderDataList(data: any) {
  return request({
    url: "/sysNovelUserOrder/data/queryList",
    method: "get",
    params: data,
  });
}
// 首页数据
export function sysNovelUserOrderHome(data: any) {
  return request({
    url: "/sysNovelUserOrder/home/queryList",
    method: "get",
    params: data,
  });
}
// 首页数据列表
export function sysNovelUserOrderHomeListBottom(data: any) {
  return request({
    url: "/sysNovelUserOrder/home/queryListBottom",
    method: "get",
    params: data,
  });
}
// 保存数据
export function sysNovelConfigSave(data: any) {
  return request({
    url: "/sysNovelConfig/save",
    method: "post",
    data,
  });
}
// 删除数据
export function sysNovelConfigDel(data: any) {
  return request({
    url: "/sysNovelConfig/del",
    method: "post",
    data,
  });
}
//用户列表
export function userQueryPageList(data: any) {
  return request({
    url: "/appUser/queryPageList",
    method: "get",
    params: data,
  });
}
//用户新增
export function userAddAppUser(data: any) {
  return request({
    url: "/appUser/addAppUser",
    method: "post",
    data,
  });
}
//用户更新
export function userUpdateAppUser(data: any) {
  return request({
    url: "/appUser/updateAppUser",
    method: "post",
    data,
  });
}
//用户充值
export function userRecharge(data: any) {
  return request({
    url: "/appUser/recharge",
    method: "post",
    data,
  });
}
//用户退款
export function userReBack(data: any) {
  return request({
    url: "/appUser/reBack",
    method: "post",
    data,
  });
}
//钱包明细列表
export function getWalletList(data: any) {
  return request({
    url: "/appUser/getWalletList",
    method: "get",
    params: data,
  });
}
// 钱包明细导出
export function exportWalletXls(data: any) {
  return request({
    url: "/appUser/getSysWalletxls",
    method: "get",
    params: data,
    responseType: "blob",
  });
}
// 钱包明细审核
export function walletCheck(data: any) {
  return request({
    url: "/appUser/walletCheck",
    method: "post",
    data,
  });
}
//代理列表
export function appUserAgentList(data: any) {
  return request({
    url: "/appUser/agent/list",
    method: "get",
    params: data,
  });
}
//广告账户管理
export function sysAdsQueryList(data: any) {
  return request({
    url: "/sysAds/queryList",
    method: "get",
    params: data,
  });
}
//广告账户更新
export function sysAdsSave(data: any) {
  return request({
    url: "/sysAds/save",
    method: "post",
    data,
  });
}
//支付管理
export function sysPayQueryList(data: any) {
  return request({
    url: "/sysPay/queryList",
    method: "get",
    params: data,
  });
}
//删除列表
export function sysPayDelList(data: any) {
  return request({
    url: "/sysAds/delList",
    method: "get",
    params: data,
  });
}
//删除列表删除
export function sysPayDelListdel(data: any) {
  return request({
    url: "/sysAds/del",
    method: "post",
    data,
  });
}
//审核到账
export function sysPayToAds(data: any) {
  return request({
    url: "/sysPay//toAds",
    method: "post",
    data,
  });
}
//审核退回
export function sysPayReAds(data: any) {
  return request({
    url: "/sysPay/reAds",
    method: "post",
    data,
  });
}
//bm列表
export function bmQueryList(data: any) {
  return request({
    url: "/sysBm/queryList",
    method: "get",
    params: data,
  });
}
// BM解绑
export function bmDel(data: any) {
  return request({
    url: "/sysBm/del",
    method: "post",
    data,
  });
}
// BM绑定
export function bmSave(data: any) {
  return request({
    url: "/sysBm/save",
    method: "post",
    data,
  });
}

// BM审核申请列表
export function sysBmQueryApplyList(data: any) {
  return request({
    url: "/sysBm/queryApplyList",
    method: "get",
    params: data,
  });
}

// 审核BM
export function sysBmApplySave(data: any) {
  return request({
    url: "/sysBm/apply/save",
    method: "post",
    data,
  });
}
// 代理列表模块
export function sysUserQueryList(data: any) {
  return request({
    url: "/sysUser/queryList",
    method: "get",
    params: data,
  });
}
// 新增代理信息
export function sysUserAdd(data: any) {
  return request({
    url: "/sysUser/add",
    method: "post",
    data,
  });
}
// 修改代理信息
export function sysUserUpdate(data: any) {
  return request({
    url: "/sysUser/update",
    method: "post",
    data,
  });
}
export function sysUserResetPassword(data: any) {
  return request({
    url: "/sysUser/resetPassword",
    method: "post",
    data,
  });
}
// 客户联系页面保存
export function sysUserCustomerUpdate(data: any) {
  return request({
    url: "/sysUser/customer/update",
    method: "post",
    data,
  });
}
// 获取用户信息
export function sysUserQuery(data: any) {
  return request({
    url: "/sysUser/query",
    method: "get",
    params: data,
  });
}
// 创建者(户)等分页列表（多页下拉，如 /sysUser/ads/queryList）
export function sysUserAdsQueryList(data: any) {
  return request({
    url: "/sysUser/ads/queryList",
    method: "get",
    params: data,
  });
}
// 工单列表
export function workQueryList(data: any) {
  return request({
    url: "/work/queryList",
    method: "get",
    params: data,
  });
}
// 审核工单
export function workSave(data: any) {
  return request({
    url: "/work/save",
    method: "post",
    data,
  });
}
// 菜单列表
export function menuQueryList(data: any) {
  return request({
    url: "/role/queryMenu",
    method: "post",
    data,
  }); 
}
// 角色列表
export function roleQueryPageList(data: any) {
  return request({
    url: "/role/queryPageList",
    method: "post",
    data,
  });
}
// 角色权限列表
export function roleQueryDetails(data: any) {
  return request({
    url: "/role/queryDetails",
    method: "post",
    data,
  });
}
// 修改角色权限
export function roleUpdateMenu(data: any) {
  return request({
    url: "/role/updateMenu",
    method: "post",
    data,
  });
}
// 添加角色
export function roleAdd(data: any) {
  return request({
    url: "/role/add",
    method: "post",
    data,
  });
}
// 广告数据管理列表
export function sysDataQueryList(data: any) {
  return request({
    url: "/sysData/queryList",
    method: "get",
    params: data,
  });
}
// 广告数据新增或修改
export function sysDataSave(data: any) {
  return request({
    url: "/sysData/save",
    method: "post",
    data,
  });
}
// 广告数据删除
export function sysDataDel(data: any) {
  return request({
    url: "/sysData/del",
    method: "post",
    data,
  });
}
// 广告数据 BM/指纹列表
export function sysDataQueryFingerIdList(data: any) {
  return request({
    url: "/sysData/queryFingerIdList",
    method: "get",
    params: data,
  });
}
// 批量停用xls
export function sysDataStateXls(data: any) {
  return request({
    url: "/sysData/state/xls",
    method: "post",
    data,
  });
}
// 图表-未分配-消耗
export function sysDataStateNotUseExpend(data: any) {
  return request({
    url: "/sysData/state/notUse/expend",
    method: "post",
    data,
  });
}
// 图表-未分配-未消耗
export function sysDataStateNotUseNotExpend(data: any) {
  return request({
    url: "/sysData/state/notUse/notExpend",
    method: "post",
    data,
  });
}
// 图表-被封账户
export function sysDataStateStop(data: any) {
  return request({
    url: "/sysData/state/stop",
    method: "get",
    params: data,
  });
}
// 导出禁用账户 xls
export function sysDataGetAccountStopXls() {
  return request({
    url: "/sysData/getAccountStop/xls",
    method: "get",
    responseType: "blob",
  });
}
// 图表-使用中
export function sysDataStateUse(data: any) {
  return request({
    url: "/sysData/state/use",
    method: "get",
    params: data,
  });
}
// 名称待办列表
export function sysNameQueryList(data: any) {
  return request({
    url: "/sysName/queryList",
    method: "get",
    params: data,
  });
}
// 名称待办处理
export function sysNameSave(data: any) {
  return request({
    url: "/sysName/save",
    method: "post",
    data,
  });
}
// 资金清零
export function sysAdsCleanAmount(data: any) {
  return request({
    url: "/sysAds/cleanAmount",
    method: "post",
    data,
  });
}
// 额度递减
export function sysAdsSubAmount(data: any) {
  return request({
    url: "/sysAds/subAmount",
    method: "post",
    data,
  });
}
// 日期消耗列表
export function sysAdsExpendList(data: any) {
  return request({
    url: "/sysAds/expendList",
    method: "get",
    params: data,
  });
}
// 消耗总计
export function sysAdsExpendCount(data: any) {
  return request({
    url: "/sysAds/expendCount",
    method: "get",
    params: data,
  });
}
// 日期修改消耗
export function sysAdsSaveExpend(data: any) {
  return request({
    url: "/sysAds/saveExpend",
    method: "post",
    data,
  });
}

// 根据表格地址更新消耗
export function sysAdsXls(data: any) {
  return request({
    url: "/sysAds/xls",
    method: "post",
    data,
  });
}
// 获取回收详情
export function sysAdsRecycleInfo(data: any) {
  return request({
    url: "/sysAds/recycle/info",
    method: "get",
    params: data,
  });
}

// 消耗列表查询
export function sysExpendQueryList(data: any) {
  return request({
    url: "/sysExpend/queryList",
    method: "get",
    params: data,
  });
}

// 消耗统计-按天
export function sysExpendDay(data: any) {
  return request({
    url: "/sysExpend/day",
    method: "get",
    params: data,
  });
}

// 消耗统计-按时区
export function sysExpendGmt(data: any) {
  return request({
    url: "/sysExpend/gmt",
    method: "get",
    params: data,
  });
}

// 消耗统计-按月
export function sysExpendMonth(data: any) {
  return request({
    url: "/sysExpend/moth",
    method: "get",
    params: data,
  });
}
// 回收账户
export function sysAdsRecycle(data: any) {
  return request({
    url: "/sysAds/recycle",
    method: "post",
    data,
  });
}

// 回收记录列表
export function recycleQueryList(data: any) {
  return request({
    url: "/recycle/queryList",
    method: "get",
    params: data,
  });
}

// 回收记录导出xls
export function recycleXls(data: any) {
  return request({
    url: "/recycle/xls",
    method: "get",
    params: data,
    responseType: "blob",
  });
}

// 信用卡流水列表
export function sysCardQueryList(data: any) {
  return request({
    url: "/sysCard/queryList",
    method: "get",
    params: data,
  });
}
// 文件上传
export function commonUpload(data: any) {
  return request({
    url: "/common/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 通知列表查询
export function sysNoticeQueryList(data: any) {
  return request({
    url: "/notice/queryList",
    method: "get",
    params: data,
  });
}

// 通知保存（添加或修改）
export function sysNoticeSave(data: any) {
  return request({
    url: "/notice/save",
    method: "post",
    data,
  });
}

// 通知删除
export function sysNoticeDel(data: any) {
  return request({
    url: "/notice/del",
    method: "post",
    data,
  });
}

// 标签列表查询
export function sysLabelQueryList(data: any) {
  return request({
    url: "/sysLabel/queryList",
    method: "get",
    params: data,
  });
}

// 标签保存（添加或修改）
export function sysLabelSave(data: any) {
  return request({
    url: "/sysLabel/save",
    method: "post",
    data,
  });
}

// 标签删除
export function sysLabelDel(data: any) {
  return request({
    url: "/sysLabel/del",
    method: "post",
    data,
  });
}

// 广告账户数据
export function sysDashboardAccountData(data: any) {
  return request({
    url: "/sysDashboard/accountData",
    method: "get",
    params: data,
  });
}

// 客户数量数据
export function sysDashboardUserData(data: any) {
  return request({
    url: "/sysDashboard/userData",
    method: "get",
    params: data,
  });
}

// 消耗数据
export function sysDashboardUserExpend(data: any) {
  return request({
    url: "/sysDashboard/userExpend",
    method: "get",
    params: data,
  });
}

// 用户消耗数据
export function sysDashboardAmountByUser(data: any) {
  return request({
    url: "/sysDashboard/amountByUser",
    method: "get",
    params: data,
  });
}

// 信用卡消耗数据
export function sysDashboardCardByUser(data: any) {
  return request({
    url: "/sysDashboard/cardByUser",
    method: "get",
    params: data,
  });
}

// 时区分类数据
export function sysDashboardGmtByUser(data: any) {
  return request({
    url: "/sysDashboard/gmtByUser",
    method: "get",
    params: data,
  });
}

// 用户账户状态（总申请成功账户数等）
export function sysDashboardAccountByUser(data: any) {
  return request({
    url: "/sysDashboard/accountByUser",
    method: "get",
    params: data,
  });
}

// 账户消耗数据（有消耗记录总账户数、昨日/本月启动消耗、昨日/本月封禁）
export function sysDashboardAccountExpend(data: any) {
  return request({
    url: "/sysDashboard/accountExpend",
    method: "get",
    params: data,
  });
}

// 导出消耗xls
export function sysExpendGetExpendxls(data: any) {
  return request({
    url: "/sysExpend/getExpendxls",
    method: "get",
    params: data,
    responseType: "blob",
  });
}